import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular-legacy';
import { TooltipDisplayRegisterContext } from '../../../services/tooltip-display.types';

@Component({
  selector: 'app-ag-grid-header-tooltip',
  template: `
    <div class="ag-grid-header-tooltip">
      <span class="ag-header-cell-text">{{ params?.displayName }}</span>
      <tooltip
        *ngIf="tooltipContext"
        [register]="tooltipContext.register"
        [tab]="tooltipContext.tab"
        [section]="tooltipContext.section"
        [field]="tooltipContext.fieldName || ''"
        [appendToBody]="true"
      ></tooltip>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      overflow: visible;
      width: 100%;
    }
    .ag-grid-header-tooltip {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      overflow: visible;
      white-space: normal;
    }
    .ag-header-cell-text {
      white-space: normal;
      word-break: break-word;
    }
  `],
})
export class AgGridHeaderTooltipComponent implements IHeaderAngularComp {
  params: any;
  tooltipContext?: TooltipDisplayRegisterContext;

  agInit(params: any): void {
    this.params = params;
    this.tooltipContext = params?.tooltipContext;
  }

  refresh(params?: any): boolean {
    if (params) {
      this.params = params;
      this.tooltipContext = params.tooltipContext;
    }
    return true;
  }
}